import React from "react";

const MP4_URL = "/cies.mp4";
const MOV_URL = "https://customer-assets.emergentagent.com/job_vela-autentica/artifacts/yiptbx62_74dedac8-e952-47bf-99c2-86d09846b340%20%281%29.MOV";
const POSTER = "/cies-poster.jpg";

export default function VideoCies() {
  return (
    <section id="cies" className="section-pad bg-navy text-white overflow-hidden" data-testid="video-section">
      <div className="container-tight grid md:grid-cols-12 gap-10 md:gap-16 items-center">
        {/* Vertical video · native 9:16 aspect preserved */}
        <div className="md:col-span-5">
          <div className="relative mx-auto w-full max-w-[360px] md:max-w-none aspect-[9/16] rounded-md overflow-hidden bg-black shadow-2xl ring-1 ring-white/10">
            <video
              className="absolute inset-0 w-full h-full object-contain bg-black"
              poster={POSTER}
              autoPlay
              muted
              loop
              playsInline
              preload="metadata"
              data-testid="cies-video"
            >
              <source src={MP4_URL} type="video/mp4" />
              <source src={MOV_URL} type="video/quicktime" />
              Tu navegador no soporta vídeo HTML5.
            </video>
          </div>
        </div>

        {/* Text */}
        <div className="md:col-span-7">
          <p className="label-eyebrow text-sand mb-4">En ruta</p>
          <h2 className="font-heading text-4xl md:text-5xl leading-[1.05] text-white" data-testid="cies-title">
            Rumbo a las Illas Atlánticas.
          </h2>
          <p className="mt-6 text-lg text-white/80 leading-relaxed max-w-xl">
            Una navegación tranquila por las Rías Baixas, con el horizonte de las Illas Cíes como parte del paisaje y el Zorba avanzando sin prisa, como se navega en los barcos con historia.
          </p>

          <div className="mt-7 flex flex-wrap items-center gap-2">
            <span className="inline-flex items-center gap-1.5 text-xs uppercase tracking-[0.18em] px-3 py-1.5 rounded-full border border-white/25 bg-white/5 text-white/85">
              🐾 Dog friendly
            </span>
            <span className="inline-flex items-center gap-1.5 text-xs uppercase tracking-[0.18em] px-3 py-1.5 rounded-full border border-white/25 bg-white/5 text-white/85">
              Rías Baixas
            </span>
            <span className="inline-flex items-center gap-1.5 text-xs uppercase tracking-[0.18em] px-3 py-1.5 rounded-full border border-white/25 bg-white/5 text-white/85">
              Illas Cíes
            </span>
            <span className="inline-flex items-center gap-1.5 text-xs uppercase tracking-[0.18em] px-3 py-1.5 rounded-full border border-white/25 bg-white/5 text-white/85">
              Illa de Ons
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}
